import App from '/src/components/App.svelte'

new App({
    target: document.body
})
